
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/snoerapport",
      function () {
        return require("private-next-pages/[region]/[resort]/snoerapport.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/snoerapport"])
      });
    }
  